import { ErrorCode } from '@approvalmax/types';
import { useLazyGetKyc } from 'shared/data/walletsKyc/v1';

export const useLazyKycData = () => {
    const [getKyc, { data, isFetching }] = useLazyGetKyc({}, { skipToastForErrorCodes: [ErrorCode.FormNotFound] });

    return {
        getKyc,
        data,
        isFetching,
    };
};
